import {Injectable} from '@angular/core';
import {LocalApiService} from '../local-api/local-api.service';
import {Observable} from 'rxjs';
import {PincodeService} from './pincode-service';
import {map} from 'rxjs/operators';


@Injectable()
export class ImplPincodeService implements PincodeService {

  constructor(private localApiService: LocalApiService) {
  }

  verifyPin(pin: string): Observable<boolean> {
    return this.localApiService.verifyPin(pin).pipe(map(response => response.result === 'valid'));
  }

  getRemainingAttempts(): Observable<number> {
    return this.localApiService.getRemainingAttempts().pipe(map(response => response.count));
  }

  getSuspensionExpiration(): Observable<number> {
    return this.localApiService.getSuspensionExpiration().pipe(map(response => this.millisToMinutes(response.result)));
  }

  private millisToMinutes(millis: number) {
    const minutes = Math.round((millis - new Date().getTime()) / 1000 / 60);
    return minutes < 1 ? 1 : minutes;
  }
}
